import React from "react";
import useCurrentUser from "hooks/useCurrentUser";

const withCurrentUser = (Wrapped) => (props) => {
  const currentUser = useCurrentUser();
  return <Wrapped {...props} currentUser={currentUser} />;
};

export default withCurrentUser;
